<template>
  <div class="project-user-info-container">
    <!-- 左侧蓝色标记和标题 -->
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">项目用户管理</h2>
      <el-button @click="goBack" icon="el-icon-back" size="small">返回项目列表</el-button>
    </div>
    
    <!-- 项目信息展示 -->
    <div class="project-info-section" v-if="currentProject">
      <div class="project-name">{{ currentProject.projectName }}</div>
      <div class="project-address">{{ getProjectAddress() }}</div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <div class="search-inputs">
        <div class="search-item">
          <el-input
            v-model="searchForm.username"
            placeholder="用户姓名"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.phone"
            placeholder="手机号"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.unit_name"
            placeholder="所属单位"
            clearable
          ></el-input>
        </div>
        
        <div class="search-item">
          <el-input
            v-model="searchForm.project_name"
            placeholder="项目名称"
            clearable
          ></el-input>
        </div>

        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">用户录入</el-button>
        </div>
      </div>
    </div>
    
    <!-- 表格区域 -->
    <div class="table-container">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
      >
        <el-table-column prop="username" label="用户姓名" min-width="120">
          <template slot-scope="scope">
            {{ maskName(scope.row.username) }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="150">
          <template slot-scope="scope">
            {{ maskPhone(scope.row.phone) }}
          </template>
        </el-table-column>
        <el-table-column label="角色类型" width="150">
          <template slot-scope="scope">
            {{ scope.row.roleDescription || scope.row.roleName }}
          </template>
        </el-table-column>
        <el-table-column prop="unitName" label="所属单位" min-width="200"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              class="edit-btn"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="text"
              class="delete-btn"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogStatus === 'add' ? '项目管理员用户录入' : '编辑项目管理员用户'"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :show-close="true"
      center
      class="user-dialog"
    >
      <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名称" prop="username">
              <el-input v-model="userForm.username" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色类型" prop="role_type">
              <el-input v-model="userForm.role_description" placeholder="项目管理员" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="userForm.phone" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属单位">
              <el-input v-model="currentUnitName" placeholder="当前单位" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="关联项目" prop="projectIds">
              <el-select
                v-model="userForm.projectIds"
                multiple
                placeholder="请选择关联项目"
                style="width: 100%"
                @change="handleProjectChange"
                :loading="!projectOptions || projectOptions.length === 0"
              >
                <el-option
                  v-for="project in projectOptions"
                  :key="project.id"
                  :label="project.projectName"
                  :value="project.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 删除确认对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
    >
      <div class="delete-dialog-content">
        <i class="el-icon-warning-outline warning-icon"></i>
        <span>确认删除该项目管理员用户信息吗？</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDelete">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { query_users_pagination, save_user, del_user } from '@/api/modules/user.js'
import { getProjectsByUnit } from '@/api/modules/projects.js'
import { getAllRoles } from '@/api/modules/role.js'
import { getUserInfo } from '@/utils/auth.js'
import { maskName as maskNameUtil, maskPhone as maskPhoneUtil } from '@/utils/mask.js'

export default {
  name: 'ProjectUserInfo',
  data() {
    return {
      // 当前项目信息
      currentProject: null,
      
      // 搜索表单
      searchForm: {
        username: '',
        phone: '',
        unit_name: '',
        project_name: ''
      },
      // 加载状态
      loading: false,
      // 表格数据
      tableData: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 对话框
      dialogVisible: false,
      dialogStatus: 'add', // 'add' 或 'edit'
      deleteDialogVisible: false,
      deleteId: null,
      // 表单数据
      userForm: {
        id: null,
        username: '',
        phone: '',
        role_type: 'PROJECT_ADMIN',
        role_description: '',
        projectIds: [], // 项目ID数组
        project_names: [], // 项目名称数组
        password: ''
      },
      // 项目选择选项
      projectOptions: [],
      // 当前用户单位ID
      currentUnitId: null,
      // 当前用户单位名称
      currentUnitName: '',
      // PROJECT_ADMIN角色ID
      projectAdminRoleId: null,
      // 表单验证规则
      rules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        projectIds: [
          { required: true, type: 'array', min: 1, message: '请至少选择一个关联项目', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 设置默认角色描述
    this.userForm.role_description = '项目管理员';
    
    this.initProjectInfo();
    this.getCurrentUnitInfo();
    this.fetchRoleList();
    this.fetchProjectList();
  },
  methods: {
    // 初始化项目信息
    initProjectInfo() {
      try {
        // 从 sessionStorage 获取项目信息
        const projectInfo = sessionStorage.getItem('currentProjectInfo')
        if (projectInfo) {
          this.currentProject = JSON.parse(projectInfo)
// 自动设置用户表单的项目ID数组
          this.userForm.projectIds = [this.currentProject.id]
          this.userForm.project_names = [this.currentProject.projectName]
        } else {
          // 如果没有项目信息，尝试从路由参数获取
          const projectId = this.$route.params.projectId
          if (projectId) {
            console.warn('未找到项目信息，项目ID:', projectId)
            this.$message.error('项目信息获取失败，请重新选择项目')
            this.goBack()
          }
        }
      } catch (err) {
        console.error('初始化项目信息出错:', err)
        this.$message.error('项目信息初始化失败')
        this.goBack()
      }
    },
    
    // 获取项目地址
    getProjectAddress() {
      if (!this.currentProject) return ''
      
      let address = ''
      if (this.currentProject.provinceName && this.currentProject.cityName && this.currentProject.districtName) {
        // 处理直辖市情况
        if (this.currentProject.provinceName === this.currentProject.cityName) {
          address = this.currentProject.provinceName + this.currentProject.districtName
        } else {
          address = this.currentProject.provinceName + this.currentProject.cityName + this.currentProject.districtName
        }
      }
      
      if (this.currentProject.detailAddress) {
        address += this.currentProject.detailAddress
      }
      
      return address || '地址信息不完整'
    },
    
    // 返回项目列表
    goBack() {
      this.$router.push('/basic/projects')
    },
    
    // 获取角色列表
    fetchRoleList() {
      getAllRoles()
        .then(response => {
if (response.data && response.data.success) {
            const roleOptions = response.data.data || [];
            
            // 查找PROJECT_ADMIN角色
            const projectAdminRole = roleOptions.find(role => role.roleName === 'PROJECT_ADMIN');
            if (projectAdminRole) {
              this.projectAdminRoleId = projectAdminRole.id;
              this.userForm.role_description = projectAdminRole.description || '项目管理员';
// 获取到角色ID后，加载项目用户列表
              this.fetchProjectUserList();
            } else {
              console.error('未找到PROJECT_ADMIN角色');
              this.$message.error('系统未配置PROJECT_ADMIN角色，请联系管理员');
            }
          } else {
            console.error('获取角色列表失败:', response.data.message);
            this.$message.error(response.data.message || '获取角色列表失败');
          }
        })
        .catch(error => {
          console.error('获取角色列表失败:', error);
          this.$message.error('获取角色列表失败，请稍后重试');
        });
    },
    
    // 获取当前用户单位信息
    getCurrentUnitInfo() {
      try {
        const userInfo = getUserInfo();
        if (userInfo && userInfo.unit_id) {
          this.currentUnitId = userInfo.unit_id;
          this.currentUnitName = userInfo.unit_name || '当前单位';
} else if (userInfo && userInfo.unitId) {
          this.currentUnitId = userInfo.unitId;
          this.currentUnitName = userInfo.unitName || '当前单位';
} else {
          console.warn('未能获取当前用户单位ID');
          this.$message.error('无法获取当前单位信息，请重新登录');
        }
      } catch (err) {
        console.error('获取用户单位信息出错:', err);
        this.$message.error('获取单位信息失败');
      }
    },
    
    // 获取项目列表
    fetchProjectList() {
      if (!this.currentUnitId) {
        console.warn('当前用户单位ID不存在，无法获取项目列表');
        this.projectOptions = [];
        return;
      }
      
      // 根据当前用户单位获取项目列表
      getProjectsByUnit(this.currentUnitId)
        .then(response => {
if (response.data && response.data.success) {
            this.projectOptions = response.data.data || [];
} else {
            console.error('获取项目列表失败:', response.data?.message);
            this.$message.error(response.data?.message || '获取项目列表失败');
            this.projectOptions = [];
          }
        })
        .catch(error => {
          console.error('获取项目列表失败:', error);
          this.$message.error('获取项目列表失败，请稍后重试');
          this.projectOptions = [];
        });
    },
    
    // 获取项目管理员用户列表
    fetchProjectUserList() {
      if (!this.projectAdminRoleId) {
        console.warn('PROJECT_ADMIN角色ID不存在，无法查询项目管理员用户');
        return;
      }
      
      this.loading = true;
      
      // 构建查询参数 - 查询指定项目的用户
      const params = {
        page: this.pagination.currentPage - 1, // 后端从0开始，前端从1开始
        size: this.pagination.pageSize,
        sortBy: 'id',
        sortDir: 'desc',
        roleId: this.projectAdminRoleId, // 使用角色ID查询项目管理员角色
        projectId: this.currentProject.id // 添加项目ID过滤
      };
      
      // 添加搜索条件
      if (this.searchForm.username) {
        params.username = this.searchForm.username;
      }
      if (this.searchForm.phone) {
        params.phone = this.searchForm.phone;
      }
      if (this.searchForm.unit_name) {
        params.unitName = this.searchForm.unit_name; // 按单位名称搜索
      }
      if (this.searchForm.project_name) {
        params.projectName = this.searchForm.project_name; // 按项目名称搜索
      }
      
// 调用API获取用户列表
      query_users_pagination(params)
        .then(response => {
if (response.data && response.data.success) {
            // 数据直接在 data.content 中
            const responseData = response.data.data;
            let userList = responseData.content || [];
            
            // 为每个用户添加角色描述信息
            userList = userList.map(user => {
              return {
                ...user,
                roleDescription: user.roleDescription || '项目管理员'
              };
            });
            
            this.tableData = userList;
            
            // 更新分页信息 - 使用Spring Data分页对象的字段
            this.pagination = {
              currentPage: responseData.number + 1, // 后端从0开始，前端从1开始
              pageSize: responseData.size,
              total: responseData.totalElements
            };   
          } else {
            this.$message.error(response.data.message || '查询失败');
          }
        })
        .catch(error => {
          console.error('查询项目管理员用户列表失败: ', error);
          this.$message.error('查询项目管理员用户列表失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 搜索方法
    handleSearch() {
      this.pagination.currentPage = 1; // 重置为第一页
      this.fetchProjectUserList();
    },
    
    // 显示新增对话框
    showAddDialog() {
      this.dialogStatus = 'add';
      this.resetForm();
      this.dialogVisible = true;
    },
    
    // 编辑操作
    handleEdit(row) {
      this.dialogStatus = 'edit';
      
      // 映射新字段名到表单字段
      this.userForm = {
        id: row.id,
        username: row.username,
        phone: row.phone,
        projectIds: row.projectIds || (row.projectId ? [row.projectId] : []),
        project_names: row.projectNames || (row.projectName ? [row.projectName] : []),
        role_type: 'PROJECT_ADMIN',
        role_description: row.roleDescription || this.userForm.role_description || '项目管理员',
        password: '' // 编辑时不修改密码
      };
      
      this.dialogVisible = true;
    },
    
    // 删除操作
    handleDelete(row) {
      this.deleteId = row.id;
      this.deleteDialogVisible = true;
    },
    
    // 确认删除
    confirmDelete() {
      this.loading = true;
      
      // 调用删除API
      del_user(this.deleteId)
        .then(response => {
if (response.data && response.data.success) {
            this.$message.success(response.data.message || '删除成功');
            // 删除成功后更新列表
            this.tableData = this.tableData.filter(item => item.id !== this.deleteId);
            this.pagination.total -= 1;
            this.deleteDialogVisible = false;
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        })
        .catch(error => {
          console.error('删除项目管理员用户失败: ', error);
          this.$message.error('删除项目管理员用户失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 重置表单
    resetForm() {
      const currentRoleDescription = this.userForm.role_description || '项目管理员';
      this.userForm = {
        id: null,
        username: '',
        phone: '',
        role_type: 'PROJECT_ADMIN',
        role_description: currentRoleDescription,
        projectIds: this.currentProject ? [this.currentProject.id] : [], // 自动设置为当前项目ID数组
        project_names: this.currentProject ? [this.currentProject.projectName] : [], // 自动设置为当前项目名称数组
        password: '' // 密码可选，后端默认为"000000"
      };
      if (this.$refs.userForm) {
        this.$refs.userForm.resetFields();
      }
    },
    
    // 提交表单
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 准备提交的数据 - 按照新接口要求构建
          const submitData = {
            username: this.userForm.username,
            phone: this.userForm.phone,
            unitId: this.currentUnitId, // 设置为当前用户单位ID
            roleId: this.projectAdminRoleId, // 设置为PROJECT_ADMIN角色ID
            projectIds: this.userForm.projectIds // 项目ID数组
          };
          
          // 如果是编辑模式，添加用户ID
          if (this.dialogStatus === 'edit' && this.userForm.id) {
            submitData.id = this.userForm.id;
          }
          
          // 如果是新增模式且设置了密码，则添加密码字段
          if (this.dialogStatus === 'add' && this.userForm.password) {
            submitData.password = this.userForm.password;
          }
          
// 使用save_user保存用户信息
          save_user(submitData)
            .then(response => {
if (response.data && response.data.success) {
                this.$message.success(response.data.message || '保存成功');
                this.dialogVisible = false;
                // 重新加载列表
                this.fetchProjectUserList();
              } else {
                this.$message.error(response.data.message || '保存失败');
              }
            })
            .catch(error => {
              console.error('保存项目管理员用户失败: ', error);
              this.$message.error('保存项目管理员用户失败，请稍后重试');
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchProjectUserList();
    },
    
    // 页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchProjectUserList();
    },
    
    // 处理项目选择变化
    handleProjectChange(selectedProjectIds) {
      // 确保selectedProjectIds是数组
      if (!Array.isArray(selectedProjectIds)) {
        selectedProjectIds = [];
      }
      
      // 更新项目名称数组
      this.userForm.project_names = selectedProjectIds.map(projectId => {
        const project = this.projectOptions.find(p => p.id === projectId);
        return project ? project.projectName : '';
      }).filter(name => name); // 过滤掉空名称
    },
    
    // 脱敏姓名
    maskName(name) {
      return maskNameUtil(name);
    },
    
    // 脱敏电话
    maskPhone(phone) {
      return maskPhoneUtil(phone);
    }
  }
}
</script>

<style lang="scss">
/* 全局对话框样式，确保对话框在页面中心 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 60px);   /* 限制最大高度 */
    
    .el-dialog__body {
      overflow-y: auto;               /* 内容过多时出现滚动条 */
      flex: 1;
    }
  }
}
</style>

<style lang="scss" scoped>
.project-user-info-container {
  background-color: #fff;
  padding: 20px;
  min-height: calc(100vh - 120px);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    
    .blue-bar {
      width: 3px;
      background-color: #1890ff;
      height: 16px;
      margin-right: 8px;
    }
    
    .page-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin: 0;
      flex: 1;
    }
  }
  
  .project-info-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    
    .project-name {
      font-size: 18px;
      font-weight: 600;
      color: #1890ff;
      margin-bottom: 8px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
    
    .project-address {
      font-size: 14px;
      color: #495057;
      font-weight: 500;
      line-height: 1.4;
    }
  }
  
  .search-area {
    margin-bottom: 20px;
    
    .search-inputs {
      display: flex;
      flex-wrap: wrap;
      
      .search-item {
        margin-right: 15px;
        margin-bottom: 10px;
        width: 200px;
      }
      
      .search-buttons {
        display: flex;
        align-items: flex-start;
        
        .el-button {
          margin-right: 10px;
        }
      }
    }
  }
  
  .table-container {
    .el-table {
      margin-bottom: 20px;
    }
    
    .edit-btn {
      color: #1890ff;
      margin-right: 15px;
    }
    
    .delete-btn {
      color: #f56c6c;
    }
  }
  
  .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .delete-dialog-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    
    .warning-icon {
      font-size: 24px;
      color: #e6a23c;
      margin-right: 10px;
    }
    
    span {
      font-size: 16px;
    }
  }
  
  .user-dialog {
    :deep(.el-dialog__header) {
      background-color: #f8f9fc;
      padding: 15px 20px;
      text-align: center;
    }
    
    :deep(.el-dialog__title) {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
    
    :deep(.el-dialog__body) {
      padding: 20px;
    }
    
    :deep(.el-form-item__label) {
      font-weight: normal;
      color: #606266;
    }
    
    :deep(.el-input__inner) {
      border-radius: 2px;
    }
    
    :deep(.el-dialog__footer) {
      padding: 10px 20px 20px;
      text-align: center;
    }
    
    :deep(.el-dialog__headerbtn) {
      top: 15px;
    }
  }
  
  // 删除确认对话框样式
  :deep(.el-dialog) {
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
